import { isString, escapeRegExp } from 'lodash-es'
import { addToArray, addSetToArray } from './arrayh'

export default function findCssRules(input) {
  const output = []
  const selector = isString(input) ? RegExp(escapeRegExp(input)) : input

  for (const styleSheet of document.styleSheets) {
    if (isStyleSheetAvailable(styleSheet)) {
      addSetToArray(output, digCssRules(styleSheet.cssRules, selector))
    }
  }

  return output
}

function isStyleSheetAvailable(styleSheet) {
  try {
    return !!styleSheet.cssRules
  } catch (_err) {
    return false
  }
}

function digCssRules(cssRules, selector) {
  const output = []

  for (const cssRule of cssRules) {
    if (selector.test(cssRule.selectorText)) {
      addToArray(output, cssRule)
    } else if (cssRule.cssRules) {
      addSetToArray(output, digCssRules(cssRule.cssRules, selector))
    }
  }

  return output
}
